export default __webpack_public_path__ + "static/media/pin1.3247d0af.png";